var en_us = {
    values: {
        'On map': 'On map',
        'Settings': 'Settings',
        'Select a trip': 'Select a trip',
        'Parameters Settings': 'Parameters Settings',
        'from the list to see its information': 'from the list to see its information',
        'Use the Shift key to tilt the map view': 'Use the Shift key to tilt the map view',
        'You need to have at least 1 parameter selected': 'You need to have at least 1 parameter selected',
        "You've selected the maximum number of parameters": "You've selected the maximum number of parameters",
        
    }
}

module.exports = en_us
